import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { setUser as setSentryUser, TraceClassDecorator } from '@sentry/angular';
import {
    address,
    blockSpecialCharachters,
    city,
    DOCTOR_ROLES,
    SUPPORT_ROLES,
    VENDOR_ROLES,
    dose_input,
    GOOGLE_RECAPTCHA_SITE_KEY,
    USER_TYPES,
    name_input,
    number_input,
    OTHER_MEDICAL_PROFESSIONAL_ROLES,
    phoneNumber,
    textareaBox,
    zipCode
} from 'src/app/constant/constant';
import {
    ApiResult,
    PromiseResult
} from 'src/app/models/PromiseResult';
import { Login_Data, UserLoginOptions } from 'src/app/models/User';
import { AuthService } from 'src/app/services/auth.service';
import { CountriesService } from 'src/app/services/countries.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { CommunicationService } from '../../shared/communication.service';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { GeocoderResponse, OtpData } from 'src/app/models/util.models';
import { GeocodingService } from 'src/app/services/geeocoding.google.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { CountrySelectedValue } from 'src/app/models/doctorregistration';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
    selector: 'app-login-health-care-prof',
    templateUrl: './login-health-care-prof.component.html',
    styleUrls: [
        './login-health-care-prof.component.css',
        './../login-home/login-home.component.css'
    ]
})
@TraceClassDecorator()
export class LoginHealthCareProfComponent implements OnInit {

    @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;

    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;

    readonly userTypes = USER_TYPES;
    login_data: Login_Data = new Login_Data();
    medical_professionals = USER_TYPES;
    userLoginOptions: UserLoginOptions;
    isVendor: boolean = false;
    base_url: string = "";
    logo_url: string = '';
    provider_id: string = "";
    slug: string = "";
    backUrl: string = "";

    constructor(
        private readonly authservice: AuthService,
        private readonly countriesService: CountriesService,
        private readonly communicationService: CommunicationService,
        public router: Router,
        private readonly utilitiesService: UtilitiesService,
        private readonly changeDetector: ChangeDetectorRef,
        private route: ActivatedRoute,
        private readonly utitilitiesService: UtilitiesService,
        private readonly geocodingService: GeocodingService,
        private recaptchaV3Service: ReCaptchaV3Service,
        private providerStateService: ProviderStateService
    ) { }

    async ngOnInit(): Promise<void> {
        sessionStorage.clear();
        this.userLoginOptions = this.utilitiesService.getLoginOptionsModel("PORTAL_BASE_URL",
            this.router.url,
            -1
        );
        this.login_data = new Login_Data();
        this.login_data.userid_data.setCurrentType(false);
        this.login_data.recaptchaData.reset();
        this.slug = this.providerStateService.getProviderSlug();
        this.provider_id = this.providerStateService.getProviderId();
        await this.getCountries();
        const path = this.router.url.split('/').slice(1);
        if (path.includes('vendor')) {
            this.isVendor = true;
        }
        await this.getCurrentLocation();
        this.logo_url = this.providerStateService.getLogoUrl();
        this.backUrl = `/${this.slug}/`;
    }

    setCountry(country_code: string) {
        if (country_code in this.login_data.userid_data.countries_code_2) {
            this.login_data.userid_data.selected_country_data = this.login_data.userid_data.countries_code_2[country_code];
            this.login_data.userid_data.selected_country_acronym = this.login_data.userid_data.selected_country_data.acronym;
        }
    }

    async getCurrentLocation() {
        let location_api_result: GeocoderResponse = new GeocoderResponse("", []);
        let user_country: string = localStorage.getItem("user_country");
        if (user_country != null) {
            this.setCountry(user_country);
        }
        else {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const point: google.maps.LatLngLiteral = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };

                    await this.geocodingService.geocodeLatLng(point)
                        .then((response: GeocoderResponse) => {
                            if (response.status === 'OK' && response.data?.length) {
                                let country_code = null;
                                response.data.forEach(element => {
                                    if (element.types.includes('country')) {
                                        // Find the country code in the address components
                                        const countryCodeComponent = element.address_components.find(component => component.types.includes('country'));
                                        if (countryCodeComponent) {
                                            // Extract the country code from the address component
                                            country_code = countryCodeComponent.short_name;
                                        }
                                    }
                                });

                                // Set the country code
                                this.setCountry(country_code);

                                // Save the country code in localStorage if needed
                                localStorage.setItem("user_country", country_code);
                            } else {
                                location_api_result.success = false;
                                location_api_result = response
                                return location_api_result;
                            }
                        })
                },
                (error) => {
                    location_api_result.error.message = "Couldn't get your location";
                    location_api_result.success = false;
                    if (error.PERMISSION_DENIED) {
                        location_api_result.error.code = 'PERMISSION_DENIED';
                    } else if (error.POSITION_UNAVAILABLE) {
                        location_api_result.error.code = 'POSITION_UNAVAILABLE';
                    } else if (error.TIMEOUT) {
                        location_api_result.error.code = 'POSITION_TIMEOUT';
                    } else {
                        location_api_result.error.code = "UNKNOWN-" + error.code;
                        location_api_result.error.message = error.message;
                    }
                    return location_api_result;
                },
                { enableHighAccuracy: true }
            );
        }
    }

    async getCountries(): Promise<void> {
        await this.countriesService
          .getCountries(this.provider_id)
          .toPromise()
          .then(async (countries) => {
            countries.forEach((ele) => {
              ele["final_value"] = ele.acronym,
                ele["final_label_string"] = ele.acronym + " (" + '+' + String(ele.phone_code) + ")";
              let country_data: CountrySelectedValue = {
                id: Number(ele.id),
                acronym: ele.acronym,
                is_national_license: ele.is_national_license,
                phone_code: '+' + String(ele.phone_code),
                country_name: ele.country_name
              };
              this.login_data.userid_data.countries_code_3[ele.acronym] = country_data;
              this.login_data.userid_data.countries_code_2[ele.iso_3166_1_aplha_2] = country_data;
            });
            this.login_data.userid_data.country_codes = this.utilitiesService.getSelectItemList(countries, "final_label_string", "final_value");
          }).catch((err) => {
            console.error(err);
          });
      }

    async onOTPCheckboxChange() {
        this.login_data.userid_data.isDisabled = false;
        this.login_data.login_api_result = new ApiResult(false);
        this.login_data.otp_data.otp_api_result = new ApiResult(false);

        if (this.login_data.otp_data.OTP_validate_api.is_password) {
            this.login_data.show_otp_button = false;
            this.login_data.show_otp_input = false;
        } else {
            this.login_data.show_otp_input = false;
            this.login_data.show_otp_button = true;
            this.login_data.otp_data = new OtpData();
        }
    }

    async login_validate_or_resend_otp() {
        this.login_data.otp_data.otp_api_result = new ApiResult(true);
        await this.authservice
            .login_validate_or_resend_otp_doctor(this.login_data.otp_data.OTP_validate_api)
            .toPromise()
            .then((result) => {
                this.login_data.otp_data.otp_api_result.PromiseResult = result;
                if (result.success) {
                    if (this.login_data.otp_data.OTP_validate_api.retry) {
                        this.set_otp_data(result);
                        this.changeDetector.detectChanges();
                        this.OTP_Input.init_countdown();
                    }
                    else {
                        this.login_set_data(result);
                    }
                }
                this.login_data.otp_data.otp_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.login_data.otp_data.otp_api_result.ServerError = error.error;
                this.login_data.otp_data.otp_api_result.PromiseResult.success = false;
                this.login_data.otp_data.otp_api_result.Posting = false;
            })
    }

    set_otp_data(result: PromiseResult) {
        this.login_data.otp_data.OTP_validate_api.service_id = result.data.service_id;
        this.login_data.otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
    }

    login_set_data(result: PromiseResult) {
        sessionStorage.setItem('userid', result.data.userid);
        sessionStorage.setItem('authtoken', result.data.authtoken);
        sessionStorage.setItem(
            'medical_profession_role',
            result.data.role_id
        );
        sessionStorage.setItem('email', 'default');
        sessionStorage.setItem('name', 'default');
        sessionStorage.setItem('refresh_token', result.data.refreshToken);
        sessionStorage.setItem('refresh', Boolean(true).toString());
        let medical_profession_role = Number(result.data.role_id);
        let doctor_roles: number[] = DOCTOR_ROLES;
        let support_roles: number[] = SUPPORT_ROLES;
        let vendor_roles: number[] = VENDOR_ROLES;
        let other_medical_roles: number[] = OTHER_MEDICAL_PROFESSIONAL_ROLES;
        let dashboard = this.medical_professionals.DOCTOR;
        if (doctor_roles.includes(medical_profession_role)) {
            dashboard = this.medical_professionals.DOCTOR;
        } else if (
            other_medical_roles.includes(medical_profession_role)
        ) {
            dashboard = this.medical_professionals['OTHER-MEDICAL-PROFESSIONALS'];
        }
        else if (support_roles.includes(medical_profession_role)) {
            dashboard = this.medical_professionals['SUPPORT'];
        }
        else if (vendor_roles.includes(medical_profession_role)) {
            dashboard = this.medical_professionals['VENDOR'];
        }
        setSentryUser({
            email: this.login_data.login_modal.email,
            id: result.data.userid,
            role: dashboard,
            role_id: medical_profession_role
        });
        //Todo: need to change this based on role
        this.setUser(result.data);
        if (result.data.has_agreed != null && !result.data.has_agreed) {
            return this.router.navigate(['/', this.slug, dashboard, 'agreement']);
        }
    
        if (this.login_data.return_url == null) {
            return this.router.navigate(['/', this.slug, dashboard]);
        } else if (this.login_data.return_url != null) {
            return this.router.navigate(['/', this.slug, this.login_data.return_url]);
        }
        return;
    }

    async signInDoctor(): Promise<void> {
        this.login_data.login_api_result = new ApiResult(true);
        this.login_data.recaptchaData.reset();
        this.login_data.login_modal.provider_id = this.provider_id
        await this.authservice
            .loginDoctor(this.login_data.login_modal)
            .toPromise()
            .then((result) => {
                this.login_data.login_api_result.PromiseResult = result;
                if (result.success) {

                    if (this.login_data.otp_data.OTP_validate_api.is_password) {
                        this.login_set_data(result);
                    }
                    else {
                        this.login_data.otp_data.OTP_validate_api.user_guid = result.data.userid;
                        this.login_data.show_otp_input = true;
                        this.login_data.show_otp_button = false;
                        this.login_data.userid_data.isDisabled = true;
                        this.set_otp_data(result);
                        this.changeDetector.detectChanges();
                        this.OTP_Input.init_countdown();
                    }
                }
                else{
                   this.login_data.show_otp_input = false;
                    this.login_data.show_otp_button = true;
                }
                this.login_data.login_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.login_data.login_api_result.ServerError = error.error;
                this.login_data.login_api_result.PromiseResult.success = false;
                this.login_data.login_api_result.Posting = false;
            });
    }

    async loginFormSubmit() {
        if (this.login_data.userid_data.isPhoneNumber()) {
            this.login_data.userid_data.contact_number = this.login_data.userid_data.selected_country_data.phone_code + this.login_data.userid_data.userid_value;
            this.login_data.login_modal.email = this.login_data.userid_data.contact_number;
            if (!this.login_data.otp_data.OTP_validate_api.is_password) {
                this.login_data.login_modal.password = '';
            }
        }
        else {
            this.login_data.userid_data.email = this.login_data.userid_data.userid_value;
            this.login_data.login_modal.email = this.login_data.userid_data.userid_value;
        }
        await this.signInDoctor();
    }

    async otp_resend() {
        this.login_data.otp_data.OTP_validate_api.retry = true;
        await this.login_validate_or_resend_otp();
    }

    async otpVerifySubmit() {
        this.login_data.otp_data.OTP_validate_api.retry = false;
        await this.login_validate_or_resend_otp();
    }

    setUser(user: any) {
        this.communicationService.setUser(user);
    }

    resolved(captchaResponse: any) {
        this.login_data.recaptchaData.recaptcha_value = captchaResponse;
        this.login_data.login_modal.recaptcha = this.login_data.recaptchaData.recaptcha_value;
    }

    openLink(base_url_name: string, link: string, target: string): void {
        this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }

    getEmptyStringChecker(value: string) {
        return this.utilitiesService.getEmptyStringChecker(value);
    }

    isPosting(): boolean {
        return this.login_data.login_api_result.Posting ||
            this.login_data.otp_data.otp_api_result.Posting;
    }
    async getOTP() {
        this.login_data.login_modal.password = '';
        this.recaptchaV3Service.execute('importantAction')
            .toPromise().then((token: string) => {
                if (token != null) {
                    this.login_data.login_modal.recaptcha = token;
                }

                this.loginFormSubmit();
            });

    }
    async loginmain() {
        if (!this.login_data.otp_data.OTP_validate_api.is_password) {
            await this.otpVerifySubmit();
        }
        else {
            this.recaptchaV3Service.execute('importantAction')
                .subscribe((token: string) => {
                    if (token != null) {
                        this.login_data.login_modal.recaptcha = token;
                    }
                    this.loginFormSubmit();

                });
        }
    }

}
